import React from 'react';

const Input = ({
  name, label, error, ...rest
}) => (
  <div className="form__group">
    {error && (
      <label className="form__label--error" htmlFor={label}>
        {error}
      </label>
    )}
    <input
      {...rest}
      name={name}
      id={name}
      className="form__input"
      autoComplete="none"
    />
    <label htmlFor={name} className="form__label">
      {label}
    </label>
  </div>
);

export default Input;
